// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"f1e2b119","263":"ddcf3682","850":"dc92cc1a","932":"1beee118"}[chunkId] + ".css";
};